<template>
  <div class="clearfix">
    <petition-lockable-field-layout :field-name="fieldName" :label="label" :show-lock="showLock"
                                    :can-change-lock="canChangeLock" :initial-locked="initialLocked"
                                    :lock-update-path="lockUpdatePath">
      <template #readonly-field>
        <span v-for="selectedCategory in selectedCategories" :key="selectedCategory[1]" class="btn capsule">
          {{ selectedCategory[0] }}
          <input type="hidden" :value="selectedCategory[1]" name="petition[category_ids][]">
        </span>
      </template>
      <template #editable-field>
        <div class="petition-categories">
          <alert v-if="tooManyCategories" class="mt-3" alert-class="warning">
            {{ tooManyCategoriesText }}
          </alert>

          <selector-input v-if="useDropdown"
                          class="mt-2"
                          :field="categoryFieldName"
                          :initial-value="selectedCategoryId"
                          :options="categoryOptions"
                          :validation-errors="validationErrors"
                          @changed="updateSelectedCategory" />
          <component :is="checkboxesInputComponent" v-else
                     class="mt-2"
                     :options="categoryOptions"
                     :name-for-input-field="categoryFieldName"
                     :value="selectedCategoryIds"
                     :validation-errors="validationErrors"
                     @changed="updateSelectedCategories" />
        </div>
      </template>
    </petition-lockable-field-layout>
  </div>
</template>

<script>
import Alert from '../components/alert'
import CheckboxesInput from '../components/inputs/checkboxes-input'
import FieldWithLock from '@/mixins/field-with-lock'
import PetitionLockableFieldLayout from '@/components/petition-lockable-field-layout'
import SelectorInput from '../components/inputs/selector-input'

export default {
  components: { Alert, CheckboxesInput, PetitionLockableFieldLayout, SelectorInput },

  mixins: [FieldWithLock],

  props: {
    categoryOptions: {
      type: Array,
      required: false,
      default: () => []
    },
    checkboxesInputComponent: {
      type: Object,
      required: false,
      default: () => CheckboxesInput
    },
    initialCategoryIds: {
      type: Array,
      required: true
    },
    maxReasonableCategories: {
      type: Number,
      required: true
    },
    objectName: {
      type: String,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    tooManyCategoriesText: {
      type: String,
      required: true
    },
    useDropdown: {
      type: Boolean,
      default: false
    },
    validationErrors: {
      type: Array,
      default: () => []
    }
  },

  emits: ['changed'],

  data() {
    return {
      fieldName: 'categories',
      selectedCategoryIds: this.initialCategoryIds,
      lockFieldName: `${this.objectName}[categories_locked]`,
      categoryFieldName: `${this.objectName}[category_ids][]`
    }
  },

  computed: {
    label() {
      return this.showLabel ? this.i18n.t('activerecord.models.category.other') : null
    },

    selectedCategoryId() {
      if (this.selectedCategoryIds.length > 0) {
        return this.selectedCategoryIds[0]
      } else {
        return ''
      }
    },

    selectedCategories() {
      return this.selectedCategoryIds.map(categoryId => this.categoryOptionForId(categoryId))
    },

    tooManyCategories() {
      return this.selectedCategoryIds.length > this.maxReasonableCategories
    }
  },

  methods: {
    categoryOptionForId(categoryId) {
      return this.categoryOptions.filter(categoryOption => categoryOption[1] === categoryId)[0]
    },

    updateSelectedCategories(newCategoryIds) {
      this.selectedCategoryIds = newCategoryIds
      this.$emit('changed', newCategoryIds)
    },

    updateSelectedCategory(newCategoryId) {
      const categoryIdInt = parseInt(newCategoryId)
      this.updateSelectedCategories([ categoryIdInt ])
      this.$emit('changed', [ categoryIdInt ])
    }
  }
}
</script>

<style lang="scss" scoped>

.capsule:not(:last-child) {
  margin-right: 6px;
}

</style>
